

import React from "react";
import ThongKePage from "../thong-ke";
const HomePage = () => {
  return (
    <React.Fragment>
      <ThongKePage />
    </React.Fragment >
  );
}
export default HomePage
